import { createFileRoute } from '@tanstack/react-router'

import PageToolSocialMediaPreview from '../pages/PageToolSocialMediaPreview'

export const Route = createFileRoute('/tools/social-media-preview')({
  component: PageToolSocialMediaPreview
})
